import React, { Component } from "react";
import { connect } from "react-redux";
import MetisMenu from "react-metismenu";
import {
  TabContent,
  TabPane,
  Nav,
  NavLink as TabLink,
  NavItem,
} from "reactstrap";
import { Switch, Route, Link } from "react-router-dom";
import DefaultLink from "./DefaultLink";
import Header from "../Shared/Header";
import Footer from "../Shared/Footer";
import Routes, { studentRoutes } from "../Route";
import {
  openLeftSidebarAction,
  openRightSidebarAction,
  openSettingbarAction,
  changeThemeColorAction,
  fontAction,
  darkModeAction,
  fixNavbarAction,
  darkHeaderAction,
  iconColorAction,
  darkSidebarAction,
  gradientColorAction,
  boxShadowAction,
  boxLayoutAction,
  darkMinSidebarAction,
  rtlAction,
  menuGridAction,
} from "../../actions/settingsAction";
import {
  universityAdminMenu,
  admissionMenu,
  studentMetisMenu
} from "./metisMenu";
import classnames from "classnames";

class StudentMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuTitle: "St. Andrews College",
      settingTab: "Settings",
      rightTab: "statistics",
      menuType: false,
      toggleThemeBar: false,
      openChatBar: false,
      isMenuSet: false,
      admissionMenu: [],
      uniMenu: []
    };
  }

  componentDidMount() {
    const { permissions = {}, isSuperAdmin } = this.props;
    if (Object.keys(permissions).length && !isSuperAdmin) {
      const adMenu = this.getAdminMenu(permissions);
      const newUniMenu = this.getMetisMenu(permissions);
      this.setState({
        admissionMenu: adMenu,
        uniMenu: newUniMenu,
        isMenuSet: true
      })
    }
  }

  closeBar = () => {
    // this.props.openRightSidebarAction(false);
    this.setState({ toggleThemeBar: false });
  };
  openThemeBarAction = () => {
    this.setState({ toggleThemeBar: !this.state.toggleThemeBar });
  };
  openChatBarAction = () => {
    this.setState({ openChatBar: !this.state.openChatBar });
  };
  toggleAction = () => {
    const { menuGrid, menuGridAction } = this.props;
    this.setState({ menuType: false });
    menuGridAction(!menuGrid);
  };

  getMetisMenu = (permissions = {}) => {
    const menu = [];

    universityAdminMenu.forEach((menuItem, idx) => {
      const { permission_code = '', displayToAll = false, checkEdit = false } = menuItem;
      if (displayToAll) {
        menuItem.id = idx + 1;
        menu.push(menuItem);
      }
      if (permission_code && permissions[permission_code] && permissions[permission_code].read && !displayToAll) {
        if (checkEdit) {
          if (permissions[permission_code].update) {
            menuItem.id = idx + 1;
            menu.push(menuItem);
          }
        } else {
          menuItem.id = idx + 1;
          menu.push(menuItem);
        }
      }
    });
    return menu;
  }

  getAdminMenu = (permissions = {}) => {
    const menu = [];
    admissionMenu.forEach((menuItem, idx) => {
      const { permission_code = '', displayToAll = false } = menuItem;
      if (displayToAll) {
        menuItem.id = idx + 1;
        menu.push(menuItem);
      }
      if (permission_code && permissions[permission_code] && permissions[permission_code].read && !displayToAll) {
        menuItem.id = idx + 1;
        menu.push(menuItem);
      }
    });

    return menu;
  }

  render() {
    const {
      openRightSidebarAction,
      toggleRightBar,
      openSettingbarAction,
      toggleSettingbar,
      openLeftSidebarAction,
      toggleLeftBar,
      changeThemeColorAction,
      themeColor,
      fontAction,
      darkModeAction,
      isDarkMode,
      fixNavbarAction,
      isFixNavbar,
      darkHeaderAction,
      isDarkHeader,
      iconColorAction,
      isIconColor,
      gradientColorAction,
      isGradientColor,
      darkSidebarAction,
      isDarkSidebar,
      darkMinSidebarAction,
      isMinSidebar,
      boxShadowAction,
      isBoxShadow,
      boxLayoutAction,
      isBoxLayout,
      rtlAction,
      isRtl,
      menuGrid,
      permissions = {},
      isSuperAdmin
    } = this.props;
    const { menuType, openChatBar, settingTab, rightTab, admissionMenu: newAdminMenu = [], uniMenu = [] } = this.state;
    return (
      <>
        <div id="main_content">
          <div
            id="header_top"
            className={`header_top ${isMinSidebar ? "dark" : ""}`}
          >
            <div className="container">
              <div className="hleft">
                <Link className="header-brand" to="/">
                  <img alt="logo" src="./assets/logo (1).png" />
                </Link>
                <div className="dropdown">
                  <span
                    onClick={() => openLeftSidebarAction(!toggleLeftBar)}
                    className="nav-link icon menu_toggle"
                  >
                    <i className="fe fe-align-center"></i>
                  </span>
                </div>
              </div>
              <div className="hright">
                <Link to="login" className="nav-link icon settingbar">
                  <i className="fe fe-power"></i>
                </Link>
              </div>
            </div>
          </div>

          {/* <!-- Start Main leftbar navigation --> */}
          <div id="left-sidebar" className="sidebar">
            <h5 className="brand-name">
              {this.state.menuTitle}
            </h5>
            <ul className="nav nav-tabs" style={{ justifyContent: "center" }}>
              <li className="nav-item">
                <span
                  className={`nav-link ${!menuType ? " active" : ""}`}
                  data-toggle="tab"
                  onClick={() => this.setState({ menuType: false })}
                >
                  Student Menu
                </span>
              </li>
            </ul>
            {menuGrid ? (
              <>
                <div className="tab-content mt-3">
                  <div
                    className={`tab-pane fade${!menuType ? " show active" : ""
                      }`}
                    id="menu-uni"
                    role="tabpanel"
                  >
                    <nav className="sidebar-nav">
                      <MetisMenu
                        className="metismenu sidebar-nav"
                        content={studentMetisMenu}
                        noBuiltInClassNames={true}
                        classNameContainer="metismenu-container"
                        classItemActive="active"
                        classNameLink="metismenu-link"
                        classNameItem="metismenu-item"
                        iconNamePrefix="fa fa-"
                        classNameStateIcon="metismenu-state-icon mr-3 mt-n1"
                        classNameContainerVisible="visible"
                        iconNameStateVisible="caret-left rotate-minus-90"
                        iconNameStateHidden="caret-left"
                        LinkComponent={(e) => <DefaultLink itemProps={e} />}
                      />
                    </nav>
                  </div>
                  <div
                    className={`tab-pane fade${menuType ? " show active" : ""}`}
                    id="menu-admin"
                    role="tabpanel"
                  >
                    <nav className="sidebar-nav">
                      <MetisMenu
                        className="metismenu sidebar-nav"
                        content={studentMetisMenu}
                        noBuiltInClassNames={true}
                        classNameContainer="metismenu-container"
                        classItemActive="active"
                        classNameLink="metismenu-link"
                        classNameItem="metismenu-item"
                        iconNamePrefix="fa fa-"
                        classNameStateIcon="metismenu-state-icon mr-3 mt-n1"
                        classNameContainerVisible="visible"
                        iconNameStateVisible="caret-left rotate-minus-90"
                        iconNameStateHidden="caret-left"
                        LinkComponent={(e) => <DefaultLink itemProps={e} />}
                      />
                    </nav>
                  </div>
                </div>
              </>
            ) : (
              <div className="tab-content mt-3">
                <div
                  className={`tab-pane fade${!menuType ? " show active" : ""}`}
                  id="menu-uni"
                  role="tabpanel"
                >
                  <nav className="sidebar-nav">
                    <MetisMenu
                      className="metismenu sidebar-nav"
                      content={studentMetisMenu}
                      noBuiltInClassNames={true}
                      classNameContainer="metismenu-container"
                      classItemActive="active"
                      classNameLink="metismenu-link"
                      classNameItem="metismenu-item"
                      iconNamePrefix="fa fa-"
                      classNameStateIcon="metismenu-state-icon mr-3 mt-n1"
                      classNameContainerVisible="visible"
                      iconNameStateVisible="caret-left rotate-minus-90"
                      iconNameStateHidden="caret-left"
                      LinkComponent={(e) => <DefaultLink itemProps={e} />}
                    />
                  </nav>
                </div>
                <div
                  className={`tab-pane fade${menuType ? " show active" : ""}`}
                  id="menu-admin"
                  role="tabpanel"
                >
                  <nav className="sidebar-nav">
                    <MetisMenu
                      className="metismenu sidebar-nav"
                      content={studentMetisMenu}
                      noBuiltInClassNames={true}
                      classNameContainer="metismenu-container"
                      classItemActive="active"
                      classNameLink="metismenu-link"
                      classNameItem="metismenu-item"
                      iconNamePrefix="fa fa-"
                      classNameStateIcon="metismenu-state-icon mr-3 mt-n1"
                      classNameContainerVisible="visible"
                      iconNameStateVisible="caret-left rotate-minus-90"
                      iconNameStateHidden="caret-left"
                      LinkComponent={(e) => <DefaultLink itemProps={e} />}
                    />
                  </nav>
                </div>
              </div>
            )}
          </div>
          <div className="page" onClick={() => this.closeBar()}>
            <Header />
            <Switch>
              {studentRoutes.map((layout, i) => {
                const { component: Something, permission_code = '' } = layout;
                const accountPermissions = permissions[permission_code] || {};
                return (
                  <Route
                    key={i}
                    exact={layout.exact}
                    path={layout.path}
                    render={() => (
                      <Something
                        isSuperAdmin={false}
                        history={this.props.history}
                        permissions={accountPermissions}
                        isStudent
                      />
                    )}
                  ></Route>
                );
              })}
            </Switch>
            <Footer />
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  toggleLeftBar: state.settings.isToggleLeftBar,
  toggleRightBar: state.settings.isToggleRightBar,
  toggleSettingbar: state.settings.isOpenSettingBar,
  themeColor: state.settings.themeColor,
  isDarkMode: state.settings.isDarkMode,
  isFixNavbar: state.settings.isFixNavbar,
  isDarkHeader: state.settings.isDarkHeader,
  isDarkSidebar: state.settings.isDarkSidebar,
  isGradientColor: state.settings.isGradientColor,
  isIconColor: state.settings.isIconColor,
  isBoxShadow: state.settings.isBoxShadow,
  isBoxLayout: state.settings.isBoxLayout,
  isMinSidebar: state.settings.isMinSidebar,
  menuGrid: state.settings.isMenuGrid,
  isRtl: state.settings.isRtl,
  permissions: state.authenticationReducer.userProfile.permissions
});

const mapDispatchToProps = (dispatch) => ({
  openLeftSidebarAction: (e) => dispatch(openLeftSidebarAction(e)),
  openRightSidebarAction: (e) => dispatch(openRightSidebarAction(e)),
  openSettingbarAction: (e) => dispatch(openSettingbarAction(e)),
  changeThemeColorAction: (e) => dispatch(changeThemeColorAction(e)),
  fontAction: (e) => dispatch(fontAction(e)),
  darkModeAction: (e) => dispatch(darkModeAction(e)),
  fixNavbarAction: (e) => dispatch(fixNavbarAction(e)),
  darkHeaderAction: (e) => dispatch(darkHeaderAction(e)),
  iconColorAction: (e) => dispatch(iconColorAction(e)),
  darkSidebarAction: (e) => dispatch(darkSidebarAction(e)),
  darkMinSidebarAction: (e) => dispatch(darkMinSidebarAction(e)),
  boxShadowAction: (e) => dispatch(boxShadowAction(e)),
  boxLayoutAction: (e) => dispatch(boxLayoutAction(e)),
  gradientColorAction: (e) => dispatch(gradientColorAction(e)),
  menuGridAction: (e) => dispatch(menuGridAction(e)),
  rtlAction: (e) => dispatch(rtlAction(e)),
});
export default connect(mapStateToProps, mapDispatchToProps)(StudentMenu);
